module.exports = __webpack_public_path__ + "static/media/Untitled-3-2.b4f94e49.jpg";